<template>
  <About></About>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'studio-product-about',

  isStudio: true,
  hideInstagramSlider: true,
  disableScrollToTop: true,
  hideMobileNav: true,
  hideCookieNotice: true
})
</script>

<script lang="ts">
import About from '@/components/product/About.vue';

export default {
  components: {
    About
  }
};
</script>